import dynamic from "next/dynamic"
import { Layout } from "components/common"
import { renderTime } from "utils/time"
import BoxRelatedTo from "components/BoxRelatedTo"
import NextHead from "next/head"
import config from "lib/config"
import fetchWithTimeout from "api/fetchWithTimeout"
import ViewPlay from "components/ViewPlay"
import { useState, useEffect, useMemo } from "react"
import { convertTypeVideo, convertTypeVideoDetail, trackGA } from "lib/func"
import { detectPlatform } from "utils/helper"
import BoxLiveChat from "components/BoxLiveChat"

// import Countly from "countly-sdk-web"
const Share = dynamic(() => import("components/Share"), { ssr: false })

export default function Video({ initVideo, query }) {
  const { name, thumbnail, created, start_time, id, type, age, is_live } = initVideo
  console.log(initVideo)

  const [isMobile, setIsMobile] = useState(false)
  const [activeTab, setActiveTab] = useState(0)

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 768) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  const showLiveChat = is_live && !isMobile
  const tabs = useMemo(() => {
    if (!showLiveChat) return null
    return [
      { label: "Trò chuyện", content: <BoxLiveChat dataVideo={initVideo} /> },
      { label: "Video liên quan", content: <BoxRelatedTo query={query} /> }
    ]
  }, [showLiveChat, initVideo, query])

  useEffect(() => {
    trackGA(initVideo?.name, convertTypeVideo(type))
    trackGA(initVideo?.name, convertTypeVideoDetail(type))
  }, [])
  return (
    <section className="max__width m-auto">
      <NextHead>
        <title>{name}</title>
        <meta name="description" content={name} />
        {/* Facebook */}
        <meta property="og:title" key="title" content={name} itemProp="headline" />
        <meta property="og:description" key="description" content={name} itemProp="description" />
        <meta property="og:image" key="image" itemProp="thumbnailUrl" content={thumbnail} />
        <meta
          property="og:url"
          key="url"
          itemProp="url"
          content={`https://onplus.com.vn/video?id=${query.id}&type=${query.type}`}
        />
        <meta key="imageWidth" property="og:image:width" content="640" />
        <meta key="imageHeight" property="og:image:height" content="360" />
        {/* Twitter  */}
        <meta name="twitter:card" value="summary" />
        <meta name="twitter:title" key="tw-title" content={name} />
        <meta name="twitter:description" key="tw-description" content={name} />
        <meta name="twitter:image" key="tw-image" content={thumbnail} />
        <meta name="twitter:image:width" key="tw-width" content="640" />
        <meta name="twitter:image:height" key="tw-height" content="360" />
        <meta
          name="twitter:url"
          itemProp="url"
          key="tw-url"
          content={`https://onplus.com.vn/video?id=${query.id}&type=${query.type}`}
        />
        <meta name="twitter:site" content="@onplus" />
        <meta name="twitter:creator" content="@onplus" />
      </NextHead>

      <div className="mb-16 pt-10 px-4 md:px-8">
        <div className="lg:grid grid-cols-3 xl:grid-cols-10 gap-4">
          <div className="col-span-2 xl:col-span-7 mb-4 ">
            <ViewPlay initVideo={initVideo} />
            <div className="text-sm md:text-2xl mt-4 mb-2 text-dark-100 md:font-semibold font-bold flex gap-[6px] items-center">
              {!is_live && (
                <div className="px-[10px] rounded-[5px] border border-white text-lg flex items-center leading-9">
                  {age || "P"}
                </div>
              )}
              {name}
            </div>
            <div className="flex justify-between items-center">
              {created && (
                <div className="md:text-sm text-xs text-dark-500">
                  {renderTime(new Date(start_time ? start_time : created))}
                </div>
              )}
              <Share id={id} />
            </div>
          </div>
          <div className="grid-cols-1 xl:col-span-3">
            {tabs ? (
              <div className="rounded-lg overflow-hidden">
                <div className="flex border-b border-[#FFFFFF]">
                  {tabs.map((tab, i) => (
                    <button
                      key={i}
                      className={`flex-1 px-4 py-3 text-base font-normal transition-colors bg-[#14213C] border-r border-[#FFFFFF] last:border-r-0 ${
                        activeTab === i
                          ? "text-lg font-semibold text-white !bg-[#28385C]"
                          : "text-dark-500 hover:text-dark-300"
                      }`}
                      onClick={() => setActiveTab(i)}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
                {tabs[activeTab].content}
              </div>
            ) : (
              <>
                <div className="bg-dark text-dark-100 px-4 py-3 border-b border-gray-700 text-lg font-semibold">
                  Video liên quan
                </div>
                <BoxRelatedTo query={query} />
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

Video.Layout = Layout

export async function getServerSideProps({ query, req }) {
  let initVideo = {},
    error = {}

  let platform = "widevine"

  try {
    const userAgent = req.headers["user-agent"] || ""
    platform = detectPlatform(userAgent)

    const params = { ...query, platform }

    const response = await fetchWithTimeout(`${config.BASE_API_URL}/publish/event/?` + new URLSearchParams(params))
    const res = await response?.json()
    if (response?.ok) {
      if (res?.data) initVideo = res?.data
    } else {
      error = res
      // console.log("API - Get Event or Video:", res)
    }
  } catch (error) {
    console.log(error)
  }
  if (error?.error_code) initVideo.error = error
  return { props: { initVideo, query } }
}
